<mono-common-back-to-navigation-bar
  data-test="lmw-base-browse-topics-back-to-home-bar"
  [linkText]="browseSubjectsPageTitle"
  linkTo="../"
  position="back-to-navigation__top"
></mono-common-back-to-navigation-bar>
<main id="content" #content class="browse browse--topics" aria-describedby="ariaMainHeaderId">
  <div class="grid-container">
    <div class="grid-x">
      <div class="cell">
        <div
          class="flex-container align-justify browse--topics__header-wrapper"
        >
        <h1 class="margin-top-0 margin-bottom-0-5" id="ariaMainHeaderId">{{ subject.title }}</h1>
        <button *ngIf="userSignedIn"
            (click)="printSummary()"
            type="button"
            class="button clear button--icon-on-right underline padding-right-0 browse__print"
          >
            <span class="bold-text" [innerHTML]="browseTopicsCms?.data?.attributes?.print | dontSanitizeHtml"></span>
            <svg
              class="icon icon--print icon--material icon--primary"
              viewBox="0 0 24 24"
            >
              <use xlink:href="#icon-print" href="#icon-print"></use>
            </svg>
          </button>
        </div>
        <p *ngIf="userSignedIn" class="lead">{{ browseTopicsCms?.data?.attributes?.description }}</p>
        <p *ngIf="!userSignedIn" class="lead" [innerHTML]="browseTopicsCms?.data?.attributes?.notSignedInDescription | dontSanitizeHtml" ></p>
      </div>
    </div>
  </div>
  <div class="grid-container browse__list-container">
    <ul class="no-bullet grid-x">
      <li class="cell small-12 medium-6 padding-bottom-1" *ngFor="let topic of topics">
        <lmw-common-subject-topic-link-button
          [text]="topic.title"
          [slug]="topic.sk"
          [completed]="topic.completed"
          type="topic"
          [userSignedIn]="userSignedIn"
          [requiresSignIn]="topic.requiresSignIn"
          iconColour="primary"
          data-test="lmw-base-browse-topic-subject-topic-link-button"
        ></lmw-common-subject-topic-link-button>
        <ng-container *ngIf="userSignedIn">
        <p
          data-test="lmw-base-browse-topic-topic-completed"
          class="topic-completed flex-container align-right margin-bottom-0 smallest-text"
          *ngIf="topic.completed"
        >
        {{ translate("Last completed: " + topic.completedDate) | async }}
        </p>
        <p
        *ngIf="!topic.completed"
          data-test="lmw-base-browse-topic-topic-not-completed"
          class="topic-not-completed flex-container align-right margin-bottom-0 smallest-text"
        >
          {{ translate("Not completed yet") | async }}
        </p>
      </ng-container>
      </li>
    </ul>
  </div>
</main>
<mono-common-back-to-navigation-bar
  data-test="lmw-base-browse-topics-back-to-home-bar"
  [linkText]="browseTopicsCms?.data?.attributes?.backToSubjects"
  linkTo="../"
  position="back-to-navigation__bottom"
></mono-common-back-to-navigation-bar>
